import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PageComponent, AuthService } from '@crowdctrl/shared';
import { IonIcon, IonSpinner, ViewDidLeave, ViewWillEnter } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { settingsOutline, gridOutline, logOutOutline } from 'ionicons/icons';
import { environment } from '../../../environments/environment';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

addIcons({
  settingsOutline,
  gridOutline,
  logOutOutline,
});

@Component({
  selector: 'app-home',
  imports: [PageComponent, IonIcon, IonSpinner, AsyncPipe],
  templateUrl: './home.component.html',
  styleUrls: [
    './home.component.css',
    '../../../../../../libs/shared/src/lib/styles/service-tiles.css',
  ],
})
export class HomeComponent implements ViewWillEnter, ViewDidLeave {
  private authService = inject(AuthService);
  private router = inject(Router);

  pageTitle$ = this.authService.authState$.pipe(
    map((user) => {
      if (user?.displayName) {
        return `Welcome, ${user.displayName}`;
      } else if (user?.email) {
        return `Welcome, ${user.email}`;
      }
      return 'Welcome';
    }),
    startWith('Welcome'),
  );
  appName = environment.appName;
  appSubtitle = environment.appSubtitle;

  /** Disables all tiles while navigating. Re-enabled on ionViewWillEnter or if navigation fails. */
  isNavigating = false;

  /** Path/key of the tile that was clicked, for selected styling and spinner. */
  selectedTilePath: string | null = null;

  ionViewWillEnter(): void {
    this.clearSelection();
  }

  ionViewDidLeave(): void {
    this.clearSelection();
  }

  private clearSelection(): void {
    this.isNavigating = false;
    this.selectedTilePath = null;
  }

  private afterNavigate(promise: Promise<boolean>): void {
    void promise.then(
      (ok) => {
        if (!ok) this.clearSelection();
      },
      () => this.clearSelection(),
    );
  }

  navigateTo(path: string, event?: Event): void {
    event?.preventDefault();
    if (this.isNavigating) return;
    this.isNavigating = true;
    this.selectedTilePath = path;
    this.afterNavigate(this.router.navigate([path]));
  }

  async signOutFromTile(event?: Event): Promise<void> {
    event?.preventDefault();
    if (this.isNavigating) return;
    this.isNavigating = true;
    this.selectedTilePath = 'signout';
    try {
      await this.authService.signOut();
    } catch {
      this.clearSelection();
    }
  }
}
